import { render, staticRenderFns } from "./Form27Layout.vue?vue&type=template&id=a8338d46&scoped=true"
import script from "./Form27Layout.vue?vue&type=script&lang=ts"
export * from "./Form27Layout.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=a8338d46&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8338d46",
  null
  
)

export default component.exports